import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.approval-forms.edit', {
        url: '/:approvalFormId/edit',
        component: 'requestCenterApprovalFormsEdit',
        resolve: {approvalForm},
    })
}

/** @ngInject */
function approvalForm($stateParams, approvalForms) {
    return approvalForms.find(p => p.id === $stateParams.approvalFormId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/edit/approval-forms-edit.state.js